import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

// Mira's knowledge approval queue (administrators). The page explains itself
// when Relay AI is off; the sidebar shows it only while it is on.
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/mira-knowledge'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'mira_knowledge_index',
          meta: { permissions: ['administrator'] },
          component: Index,
        },
      ],
    },
  ],
};
